/* ── Lucide-style inline SVGs ── */
export const DashboardIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);

export const BookingsIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10H3" />
    <path d="M9 2V6" />
    <path d="M15 2V6" />
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M7 14h.01" />
    <path d="M12 14h.01" />
    <path d="M17 14h.01" />
    <path d="M7 18h.01" />
    <path d="M12 18h.01" />
    <path d="M17 18h.01" />
  </svg>
);

export const SpacesIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

export const UsersIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const SettingsIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

export const InvoicesIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

export const ApplicationsIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <polyline points="16 11 18 13 22 9" />
  </svg>
);

export const QuotesIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="9" y1="9" x2="9" y2="9" />
  </svg>
);

export const WhatsAppNavIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

export const PaymentPlansIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 15, height: 15 }}
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export const navGroups = [
  {
    label: 'Principal',
    items: [
      {
        path: '/dashboard',
        label: 'Tableau de bord',
        desc: 'KPIs & analytiques',
        icon: DashboardIcon,
        roles: ['SUPER_ADMIN', 'ADMIN', 'MANAGER'],
      },
      {
        path: '/bookings',
        label: 'Réservations',
        desc: 'Coworking & salles',
        icon: BookingsIcon,
        roles: ['SUPER_ADMIN', 'ADMIN', 'MANAGER'],
      },
      {
        path: '/calendar',
        label: 'Calendrier',
        desc: "Planning d'occupation",
        icon: CalendarIcon,
        roles: ['SUPER_ADMIN', 'ADMIN', 'MANAGER'],
      },
      {
        path: '/spaces',
        label: 'Espaces',
        desc: 'Catalogue & configuration',
        icon: SpacesIcon,
        roles: ['SUPER_ADMIN', 'ADMIN', 'MANAGER'],
      },
    ],
  },
  {
    label: 'Gestion',
    items: [
      {
        path: '/invoices',
        label: 'Facturation',
        desc: 'Factures & paiements',
        icon: InvoicesIcon,
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        path: '/quotes',
        label: 'Devis',
        desc: 'Demandes & estimations',
        icon: QuotesIcon,
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        path: '/applications',
        label: 'Candidatures',
        desc: 'Dossiers bureaux',
        icon: ApplicationsIcon,
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        path: '/payment-plans',
        label: 'Plans de paiement',
        desc: 'Échéanciers & mensualités',
        icon: PaymentPlansIcon,
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        path: '/users',
        label: 'Utilisateurs',
        desc: 'Comptes & accès',
        icon: UsersIcon,
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
    ],
  },
  {
    label: 'Système',
    items: [
      {
        path: '/whatsapp',
        label: 'WhatsApp IA',
        desc: 'Assistant & chatbot',
        icon: WhatsAppNavIcon,
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        path: '/settings',
        label: 'Paramètres',
        desc: 'Configuration générale',
        icon: SettingsIcon,
        roles: ['SUPER_ADMIN', 'MANAGER'],
      },
    ],
  },
];
